import React from 'react';

export default function NotFound() {
  return (
    <div className="not-found">
      <div className="not-found-icon">🔍</div>
      <h1 className="not-found-title">404</h1>
      <h2 className="not-found-subtitle">Page Not Found</h2>
      <p className="not-found-text">
        The page you're looking for doesn't exist.
      </p>
      <a className="not-found-btn" href="https://buildings.honeywell.com/us/en/home">
        Visit Honeywell.com
      </a>
    </div>
  );
}
